import { recordTypes } from '@shared/schema/recordTypes.js';
import legacyActivityModels from './legacyActivityModels.js';

const recordTypeActivityModels = Object.keys(recordTypes).reduce((acc, recordTypeKey) => {
  acc[recordTypeKey] = () => ({});
  return acc;
}, {});

const activityModels = {
  ...legacyActivityModels,
  ...recordTypeActivityModels
};

export default activityModels;
